const MEILISEARCH_PUBLIC_API_KEY = process.env
  .NEXT_PUBLIC_MEILISEARCH_PUBLIC_API_KEY
  ? String(process.env.NEXT_PUBLIC_MEILISEARCH_PUBLIC_API_KEY)
  : ''

const MEILISEARCH_API_URL = process.env.NEXT_PUBLIC_MEILISEARCH_API_URL
  ? String(process.env.NEXT_PUBLIC_MEILISEARCH_API_URL)
  : ''

export default {
  MEILISEARCH_API_URL,
  MEILISEARCH_PUBLIC_API_KEY,
}
